import Vue from 'vue'

import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import VueAxios from './plugins/axios'
import i18n from './i18n'

Vue.use(VueAxios);

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
